import React from "react";
import "./confirm-finish-exam.dialog.scoped.scss";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import AppButtonComponent from "../../../../components/form/app-button";
import { icons } from "../../../../statics/icons";

interface ConfirmFinishExamDialogProps {
  show: boolean;
  onClose: (value: boolean) => void;
}

export const ConfirmFinishExamDialog: React.FC<ConfirmFinishExamDialogProps> = ({
  show,
  onClose,
}) => {
  const { t } = useTranslation();

  const handleClose = (value: boolean) => {
    onClose(value);
  };

  return (
    <Dialog
      open={show}
      onClose={() => handleClose(false)}
      maxWidth="xs"
      fullWidth
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogContent
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "1.9rem",
          padding: "1.9rem 24px",
          textAlign: "center",
        }}
      >
        <img
          src={icons.PAGES.EDUCATION.CONFIRM_FINISH_EXAM}
          alt="confirm finish exam"
        />

        <Typography
          variant="h3"
          className="font-weight-bold"
          color="textPrimary"
        >
          {t("EDUCATION_PAGE.ARE_YOU_SURE_YOU_WANT_TO_CLOSE_THE_CHECKPOINT")}
        </Typography>
      </DialogContent>
      <DialogActions
        style={{
          borderTop: "1px solid var(--border)",
          padding: "16px 24px",
          gap: "1rem",
        }}
      >
        <AppButtonComponent
          variant="text"
          color="secondary"
          size="large"
          onClick={() => handleClose(false)}
        >
          {t("CANCEL")}
        </AppButtonComponent>
        <AppButtonComponent
          variant="contained"
          color="primary"
          size="large"
          onClick={() => handleClose(true)}
        >
          {t("YES")}
        </AppButtonComponent>
      </DialogActions>
    </Dialog>
  );
};
